import React, { Fragment } from 'react';
import LazyLoad from 'react-lazyload'

import PDPReturns from '../pdp-returns';
import { Helpers } from '../../../core/src/helpers';
import { setCarouselHeight } from '../../../shared/components/carousel';
import DisclaimerTooltip from '../../../shared/components/disclaimer-tooltip';
import AccessoriesCarousel from '../pdp-acc-carousel';
import FeaturesTabContent from './features-tab-content';
import CustomContent from '../../../custom-content/custom-content-container';
import PDPIntelBadgeContainer  from '../pdp-intel-badge-container';

import '../../css/pdp-features.less';


const FEATURES_LIST_METRIC = 'pdp-features';

export const FeaturesMapper = React.memo(({ features, device, sku}) => {
    const { featuresContent=[], disclaimers=[] } = features;
    let footnoteRegex = Helpers.footnoteRegex();
    
    return featuresContent.reduce((r, f, index) => {
        const { value } = f;
        return r.concat(value.map((v,index) => {
            let hasCustomContent = false;
            if(v.id ==='Legal Disclaimers'){
                return null;
            }
            if(!!v.html){
                hasCustomContent = true;
                return <FeaturesTabContent key={'cutom-html-' + index} sku={sku} content={v}/>
            }
            else if(!!v.customContent){
                hasCustomContent = true;
                //use disclaimers from feed for custom content
                v.customContent.disclaimers = disclaimers;
                return <CustomContent key={'cutom-content-' + index} {...v.customContent} device={device} sku={sku}/>
            }
            return v.content.map((c, i) => {
                const { type } = c;
                if(type === 'featuresHtml'){
                    return c.value.map((val) => {
                        hasCustomContent = true;
                        //use disclaimers from feed for custom content
                        val.customContent.disclaimers = disclaimers;
                        return <CustomContent key={'cutom-content-' + index} {...val.customContent} device={device} sku={sku}/>
                    })
                    
                }
                return (
                    <Fragment key={c.label[0] || i}>
                        {
                            /* only display label if filler exisits */
                            <DisclaimerTooltip string={(c.filler.length > 0 && c.label[0]) || ''} footnoteRegex={footnoteRegex} disclaimers={disclaimers}>
                                {(string, replaced) => {
                                    return replaced ? <h2 tabIndex={0} aria-label={string}>{string}</h2> : 
                                            !!string ? <h2 tabIndex={string ? 0 : -1} aria-label={string} dangerouslySetInnerHTML={Helpers.createMarkup(string)}></h2> : null
                                }}
                            </DisclaimerTooltip>
                        }
                        {
                            c.filler.map((f) => {
                                f = Array.isArray(f) ? f[f.length - 1] : f;
                                //TEMP: Some pidmemo mappings dont give a path down to a string, ignore for now
                                if(typeof f === 'object'){
                                    return null
                                }
                                return (<DisclaimerTooltip  key={f} string={f} footnoteRegex={footnoteRegex} disclaimers={disclaimers}>
                                    {(string) => { 
                                        if (typeof string === 'string') { 
                                            let lineBreak = v.id == 'Key Selling Points' && !c.label[0] ? <br></br> : null;
                                            const ariaLabel = type !== 'html' ? string : undefined; 
                                            return (<React.Fragment>
                                                        <span tabIndex={0} aria-label={ariaLabel} dangerouslySetInnerHTML={ Helpers.createMarkup(string) }></span>
                                                        {lineBreak}
                                                    </React.Fragment>) 
                                        } else if (Array.isArray(string)) { 
                                            return ( 
                                            <Fragment> 
                                                {string.map((str, i) => {
                                                    const ariaLabel = type !== 'html' ? str : undefined; 
                                                    return typeof str === 'string' ? 
                                                    <span tabIndex={0} aria-label={ariaLabel} className="with-disclaimer" key={i} dangerouslySetInnerHTML={Helpers.createMarkup(str)}></span> 
                                                    : str; 
                                                })} 
                                            </Fragment>) 
                                        } 
                                    }}
                                </DisclaimerTooltip>)
                            })
                        }
                    </Fragment>
            )});
        }))
    },[])
});

class Features extends React.PureComponent {
    constructor(props) {
        super(props);
        this.carousel = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if(this.props.isActive && prevProps.isActive !== this.props.isActive && this.carousel) {
            setCarouselHeight(this.carousel.current);
        }
    }

    render(){
        let { product, device='' } = this.props;
        let { features={}, xsell=[], attributes={}, prdClass, sku, pdpConfig={} } = product;
        let { pdpFeaturesTabXsell={} } = pdpConfig;
        const isGiftCard = ["pgc","vgc"].includes((prdClass || "").toLowerCase());

        return (
            <div className={'pdp-features fv5  pdp-width-container'}>
                <FeaturesMapper features={features} device={device} sku={sku}/>
                {isGiftCard ? (
                    <a
                        className="link"
                        href="/webapp/wcs/stores/servlet/ContentView?eSpotName=GiftCardsFAQ&amp;storeId=10151&amp;langId=-1&amp;catalogId=10051#about"
                    >
                        Click here to know more about Gift Cards
                    </a>
                ) : null}
                <LazyLoad offset={300}><PDPIntelBadgeContainer /></LazyLoad>
                <div className="pdp-line"></div>
                <PDPReturns prdClass={prdClass} returnsMessage={attributes.return_policy} />
                <div className="pdp-line mobile-hide"></div>
                {xsell.length > 0 && !pdpFeaturesTabXsell.disableAccessoriesCarousel && (
                    <React.Fragment>
                        <div className="mobile-hide header">
                            <h2 tabIndex={0} aria-label="You might also be interested in">
                                You might also be interested in...
                            </h2>
                        </div>
                        <LazyLoad height={300} offset={50} once>
                            <AccessoriesCarousel
                                className="features-carousel"
                                products={xsell}
                                carouselRef={this.carousel}
                                setCarouselHeight={() => setCarouselHeight(this.carousel.current)}
                                slidesToShow={4}
                                ctaMetrics={{
                                    list: FEATURES_LIST_METRIC
                                }}
                                productClickMetrics={{
                                    'data-metrics-list': FEATURES_LIST_METRIC
                                }}
                                xsellType={FEATURES_LIST_METRIC}
                                baseProductSku={product && product.sku}
                            />
                        </LazyLoad>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default Features;
